var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlufWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 49.4 56.3",
    style: {
      enableBackground: "new 0 0 49.4 56.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:none;stroke:#FFFFFF;stroke-width:0.5;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17,50.8c1.4,2.2,6,3.3,9.6,3.3s6.5-1.1,8.4-3.4s3-5.8,3-10.4V9.8h-4.4V8.5h9.8v1.3h-3.7v30 c0,5.6-1.2,9.7-3.7,12.5s-6.8,4.1-13.1,4.1S12,55,8.7,52.4s-5-7.1-5-13.4V9.8H0V8.5h21.2v1.3h-6.4v31.5 C14.8,45.5,15.6,48.6,17,50.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M29.2,9.9c0-2.7,4.5-4.9,10-4.9s10,2.2,10,4.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M29.3,9.9c0.2-5.5,4.8-9.8,10.2-9.6c5.2,0.2,9.4,4.4,9.6,9.6"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlufWhite);
export default __webpack_public_path__ + "static/media/Fluf-White.355c4b01a471ed324d73b1e044b99031.svg";
export { ForwardRef as ReactComponent };